<template>
  <div class="detail-container">
    <div class="detail-title">本月菜金明细</div>
    <div class="break-line"/>
    <template v-show="monthOrderDatas.length && !requesting">
      <div class="order-view" ref="orderView">
        <div
          v-for="(monthOrderData, index) in monthOrderDatas"
          :key="index">
          <div class="title-time">
            <span class="icon-title">
              <img class="icon" src="../../../static/img/user/icon_dp.png">
              <span class="title">{{ monthOrderData.select_type }}</span>
            </span>
            <span class="time">订单时间：{{ monthOrderData.create_time }}</span>
          </div>
          <OrderDetailItem
            :orders="monthOrderData"
          />
        </div>
      </div>
    </template>
    <div v-if="requesting" style="color: #ff7814" class="la-pacman">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <p v-else-if="!monthOrderDatas.length" class="no-order">暂无订单</p>
    <OrderComment v-if="$store.state.user.order.show_comment_view" @getOrders="getOrders"/>
  </div>
</template>

<script>
import OrderDetailItem from './order_detail_item'
import OrderComment from './order_comment'
import '../../../static/css/pacman.css'

export default {
  name: 'Order',
  components: {
    OrderDetailItem,
    OrderComment
  },
  data () {
    return {
      monthOrderDatas: [],
      requesting: false,
      loading: false,
      pageInfo: {
        page_now: 1
      },
      isOver: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 获取订单数据
      this.getOrders()
      this.scroll()
    })
  },
  methods: {
    /**
     * 获取当日订单数据
     */
    async getOrders () {
      this.requesting = true
      let params = {
        user_id: this.$store.state.user_info.id,
        cmd: 3,
        page_now: this.pageInfo.page_now
      }
      // 请求订单数据
      this.APIS.REQUEST_ORDERS(params)
      .then((res) => {
        if (res.data.status === 0 && res.data.order_data.length > 0) {
          this.monthOrderDatas.push(...res.data.order_data)
          this.pageInfo.page_now += 1
        } else if (res.data.order_data.length === 0) {
          this.isOver = true
          this.$store.commit('show_alert', '订单加载完毕')
        }
        this.loading = false
        this.requesting = false
      })
      .catch(() => {
        this.requesting = false
        this.$store.commit('show_alert', '登陆超时，请重新登录')
        // 跳转到登陆界面
        this.$router.push('/p/login')
      })
    },
    scroll () {
      this.loading = false
      this.$nextTick(() => {
        console.log(this.$refs.orderView)
        this.$refs.orderView.addEventListener('scroll', () => {
          const offsetHeight = this.$refs.orderView.offsetHeight
          const scrollTop = this.$refs.orderView.scrollTop
          const scrollHeight = this.$refs.orderView.scrollHeight
          let bottomOfWindow = (offsetHeight + scrollTop) - scrollHeight >= -1
          if ( bottomOfWindow && this.loading == false && !this.isOver) {
            this.loading = true
            this.getOrders()
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.placeholder {
  width: 100px;
  height: 300px;
  background: #333333;
}
.detail-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .detail-title {
    width: 900px;
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
  }
  .break-line {
    width: 900px;
    margin-top: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  .la-pacman {
    margin: 50px;
  }
  .no-order {
    color: #999999;
  }
  .order-view {
    width: calc(~"100% - 16px");
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 6px;
    overflow: auto;
    .title-time {
      width: 900px;
      height: 36px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #f5f5f5;
      border: solid 1px #e0e0e0;
      margin-top: 20px;
      .icon-title {
        display: flex;
        align-items: center;
        height: 36px;
        .icon {
          width: 20px;
          height: 20px;
          margin-left: 20px;
        }
        .title {
          font-size: 16px;
          color: #333333;
          margin-left: 5px;
        }
      }
      .time {
        font-size: 14px;
        color: #333333;
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/detail.vue